<div class="deck" #deck>
  <div style="position: relative;width: 100%;height: 150px;display: flex;justify-content: center;">
    @for (card of cards; track card; let idx = $index) {
      <div #card class="card" (click)="selectCard($event, idx + 1)">
        <div class="front"></div>
      <div class="back" [ngStyle]="{
        '--card-image': 'url(https://vss.astrocenter.fr/astrocdn/game/tarot/marseille/cardmed'+((idx + 1).toString().padStart(2, '0'))+'.gif)'
      }"></div>
      </div>
    }
  </div>
  <div class="results">
    <div class="space" #space></div>
    <div class="space" #space></div>
    <div class="space" #space></div>
  </div>
</div>
